/*
 * BL-product-addons-second-v3.js · Carril de ESPEJOS agrupado por familia (2026-09-01).
 * Una FILA por familia (redondos / rectangulares), leida de `custom.addons_second`. Cada fila:
 *   [imagen] · titulo · [talla ▾] [chips de feature] [− qty +] [+precio] · [toggle]
 *
 * TRES reglas de negocio (spec Victor, cerrada el 2026-09-01):
 *  1. TALLA. Se preselecciona la del mueble: coincidencia EXACTA; si no existe, la
 *     inmediatamente INFERIOR; y si el mueble es mas estrecho que todas, la mas pequena.
 *     La medida del mueble sale de `window.__blWb3.size` (selector v3) con respaldo al select
 *     de variante nativo. La comparacion es NUMERICA sobre los digitos del valor: el nombre de
 *     la opcion llega traducido (Breite/Ancho/Largeur) y casar por texto es exactamente lo que
 *     rompio el carril de grifos en espanol.
 *  2. FEATURES ACUMULATIVAS. Un chip por producto de la familia, ordenados por numero de tags
 *     `feature-*`. Marcar antivaho enciende TAMBIEN el chip de luz, porque el producto que se
 *     lleva trae las dos. Los tags no se traducen: por eso la escalera se deduce de ellos y no
 *     del texto del metaobjeto.
 *     Dibujo y texto salen de `featureList` (la lista `custom.product_features`, traducida).
 *     Desde el 2026-09-02 cada espejo lleva sus features SUELTAS: el chip de cada nivel es la
 *     feature que ese nivel ANADE sobre el anterior (luz; luego antivaho) y el titulo de la
 *     fila las une con " + ". Un metaobjeto COMBINADO por nivel (convencion anterior) sigue
 *     funcionando por la misma regla: lo que anade el nivel es ese combinado. Un nivel con
 *     Bluetooth entra como un producto mas con tres features sueltas, sin icono nuevo.
 *  3. CANTIDAD. Stepper por fila, default 1 y sin automatismo por numero de senos (a diferencia
 *     de los grifos): un espejo ancho sobre un mueble de dos senos es tan normal como dos
 *     estrechos, asi que la decision se deja al cliente.
 *
 * CARRITO: este fichero solo PUBLICA `window.__blAddonsSecond`. Quien lo mete en el /cart/add es
 * el provider COMPUESTO de BL-product-addons-v3.js, que el snippet carga siempre.
 *
 * 2026-10-15 · elegir medida o nivel de una fila la ENCIENDE, como si se pulsara su interruptor
 * (switchOn; pruebas en tools/addons-second-v3-harness.js, seccion 13).
 */
(function () {
  'use strict';

  var QTY_MIN = 1, QTY_MAX = 10;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmtCents(c) { try { return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR' }).format(c / 100); } catch (e) { return (c / 100).toFixed(0) + ' €'; } }
  function digits(v) { var m = String(v == null ? '' : v).match(/\d+/); return m ? parseInt(m[0], 10) : null; }
  function clampQty(n) { n = parseInt(n, 10); if (!isFinite(n)) n = QTY_MIN; return Math.min(QTY_MAX, Math.max(QTY_MIN, n)); }

  // Medida del mueble. Fuente 1: el selector v3. Fuente 2 (PDPs sin ese bloque): el select de
  // variante del tema. Se excluye cualquier control DE ESTE carril para no leernos a nosotros
  // mismos y quedar enganchados en un bucle talla-espejo -> talla-espejo.
  function muebleSize() {
    var wb3 = window.__blWb3;
    var raw = (wb3 && wb3.size) || '';
    if (!raw) {
      var cands = document.querySelectorAll('variant-selects select, .product-form__input select, .product-form__input input[type="radio"]:checked');
      for (var i = 0; i < cands.length; i++) {
        if (cands[i].closest('[data-bl-addons2]')) continue;
        if (cands[i].value) { raw = cands[i].value; break; }
      }
    }
    return digits(raw);
  }

  // exacta -> inmediatamente inferior -> la mas pequena. Devuelve el VALOR de opcion, no el numero:
  // la etiqueta puede ser "60" o "60x80" y lo que casa con la variante es la cadena original.
  function pickSize(sizes, target) {
    if (!sizes || !sizes.length) return null;
    var nums = [];
    sizes.forEach(function (s) { var n = digits(s.v); if (n != null) nums.push({ s: s, n: n }); });
    if (!nums.length) return sizes[0].v;
    var asc = nums.slice().sort(function (a, b) { return a.n - b.n; });
    if (target == null) return asc[0].s.v;
    for (var i = 0; i < nums.length; i++) if (nums[i].n === target) return nums[i].s.v;
    var lower = null;
    asc.forEach(function (x) { if (x.n < target) lower = x; });   // asc ordenado: el ultimo < target es el mayor inferior
    return (lower || asc[0]).s.v;
  }

  function init() {
    document.querySelectorAll('[data-bl-addons2]').forEach(function (root) {
      if (root.dataset.blBound === '1') return;
      root.dataset.blBound = '1';
      var sectionId = root.getAttribute('data-section-id') || '';
      var dataEl = document.getElementById('bl-addons2-data-' + sectionId);
      if (!dataEl) return;
      var data; try { data = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }

      // El snippet emite una lista PLANA de espejos y la agrupacion se hace aqui: en Liquid
      // obligaba a recorrer los espejos dos veces y a llevar el conjunto de claves en una cadena
      // con delimitadores, y ahi fue donde se colo el fallo que dejaba el carril sin filas.
      // El orden de las filas es el de aparicion en `custom.addons_second`, o sea el del PIM.
      var order = [], byKey = {};
      (data.items || []).forEach(function (it) {
        if (!it || !it.id) return;
        var k = it.group || it.handle || String(it.id);
        if (!byKey[k]) {
          byKey[k] = { key: k, title: it.groupTitle || it.title || '', shape: it.shape || '',
                       shapeLabel: it.shapeLabel || '', sizeLabel: it.sizeLabel || '', products: [] };
          order.push(k);
        }
        byKey[k].products.push(it);
      });
      var groups = order.map(function (k) { return byKey[k]; }).filter(function (g) { return g.products.length; });
      if (!groups.length) return;

      // mismo guard defensivo que el carril de grifos: un contenedor ausente (snippet editado)
      // no debe lanzar y abortar el resto de carriles de la pagina
      var rowsEl = root.querySelector('[data-a2-rows]');
      if (!rowsEl) return;
      var headEl = root.querySelector('[data-a2-head]');
      var showPrice = root.getAttribute('data-show-price') !== 'false';
      var L = {
        qty: root.getAttribute('data-qty-label') || 'Menge',
        inc: root.getAttribute('data-qty-inc') || '+',
        dec: root.getAttribute('data-qty-dec') || '-',
        // preposicion traducida ("mit"/"con"/"avec") para el nivel en el titulo de la fila:
        // "Sil · Rechteckig · mit Beleuchtung + Antibeschlag". Viene de tap_hole_with en
        // minuscula; el sustantivo aleman conserva su mayuscula propia, que es lo correcto.
        withWord: root.getAttribute('data-with-label') || ''
      };
      function lblFor(tpl, name) { return String(tpl).split('~P~').join(name || ''); }

      // escalera de features: menos tags primero (luz) -> mas tags despues (luz+antivaho).
      // Array.prototype.sort es estable desde ES2019, asi que a igual numero de features manda
      // el orden del metafield, que es el que controla el PIM.
      var rows = groups.map(function (g) {
        var prods = (g.products || []).slice().sort(function (a, b) {
          return (a.features || []).length - (b.features || []).length;
        });
        return { key: g.key, g: g, prods: prods, level: 0, size: null, sizeTouched: false, qty: QTY_MIN, on: false };
      });

      function curProd(r) { return r.prods[r.level] || r.prods[0]; }

      // Features PINTABLES de un producto: la lista `featureList` (una entrada por metaobjeto)
      // o, si el JSON es anterior al 2026-09-02 y no la trae, el par featureLabel/featureIcon
      // de siempre (el ultimo metaobjeto de la lista).
      function featsOf(p) {
        if (!p) return [];
        if (p.featureList && p.featureList.length) return p.featureList;
        return p.featureLabel ? [{ handle: '', label: p.featureLabel, icon: p.featureIcon || null }] : [];
      }
      function featKey(f) { return f.handle || f.label || ''; }
      // Lo que un nivel ANADE sobre el anterior. Con features sueltas es la feature nueva (luz,
      // despues antivaho, despues Bluetooth); con un metaobjeto combinado por nivel es ese
      // combinado. Si no anade nada distinguible (dato mal cargado) se ensena la ultima feature
      // del nivel, para que el chip nunca salga vacio.
      function levelDelta(r, li) {
        var cur = featsOf(r.prods[li]);
        var prev = li > 0 ? featsOf(r.prods[li - 1]) : [];
        var seen = {};
        prev.forEach(function (f) { seen[featKey(f)] = 1; });
        var d = cur.filter(function (f) { return !seen[featKey(f)]; });
        return d.length ? d : cur.slice(-1);
      }
      function labelsOf(list) { return list.map(function (f) { return f.label; }).filter(Boolean).join(' + '); }
      function sizeEntry(r) {
        var p = curProd(r); if (!p) return null;
        var out = null;
        (p.sizes || []).forEach(function (s) { if (s.v === r.size) out = s; });
        return out;
      }
      function sellable(r) { var s = sizeEntry(r); return !!(s && s.available && s.id); }

      // Re-resuelve la talla. `force` la impone aunque el cliente ya haya tocado el desplegable
      // (solo se usa al cambiar de nivel si la talla elegida no existe en el producto nuevo).
      function syncSize(r, force) {
        var p = curProd(r); if (!p) return false;
        var has = (p.sizes || []).some(function (s) { return s.v === r.size; });
        if (!force && r.sizeTouched && has) return false;
        if (!force && r.sizeTouched && !has) force = true;   // la talla manual ya no existe: hay que re-elegir
        var next = pickSize(p.sizes, muebleSize());
        if (next === r.size) return false;
        r.size = next;
        return true;
      }
      function syncAllSizes() {
        var changed = false;
        rows.forEach(function (r) { if (syncSize(r, false)) changed = true; });
        return changed;
      }

      // SELLO DE GENERACION. Durante un swap del grouping pueden convivir el root VIEJO y el
      // NUEVO, y el viejo sigue oyendo `bl:wb3:change`: su publish() resucitaria en el payload
      // del carrito el espejo del mueble ANTERIOR. Es la misma clase de fallo P0 que se corrigio
      // en el selector v3 el 2026-08-26, y alli quedo demostrado que `isConnected` NO basta —
      // con viewTransition el root viejo sigue conectado mas de 770 ms.
      window.__blAddonsSecondGen = window.__blAddonsSecondGen || {};
      var GEN = (window.__blAddonsSecondGen[sectionId] || 0) + 1;
      window.__blAddonsSecondGen[sectionId] = GEN;
      function stale() {
        if (window.__blAddonsSecondGen[sectionId] !== GEN) return true;
        return root.isConnected === false;   // `=== false` y no `!`: sin la propiedad no se juzga
      }

      // Y se limpian las entradas de ESTA seccion antes de republicar: si el swap lleva a un
      // mueble con otras familias de espejo, las claves viejas seguirian en el global y el
      // provider las meteria en el /cart/add — el "producto anclado" que ya mordio en el v3.
      window.__blAddonsSecond = window.__blAddonsSecond || {};
      Object.keys(window.__blAddonsSecond).forEach(function (k) {
        if (k.indexOf(sectionId + '|') === 0) delete window.__blAddonsSecond[k];
      });

      // persistencia entre swaps del grouping (mismo contrato que __blWb3Selection y
      // __blAddonsV3Selection): el grouping recrea el DOM desde HTML cacheado, y sin esto el
      // carril se resetearia a apagado cada vez que cambia el color o el tirador del mueble.
      window.__blAddonsSecondSelection = window.__blAddonsSecondSelection || {};
      (function restore() {
        var saved = window.__blAddonsSecondSelection[sectionId]; if (!saved) return;
        rows.forEach(function (r) {
          var s = saved[r.key]; if (!s) return;
          if (s.level != null && s.level >= 0 && s.level < r.prods.length) r.level = s.level;
          if (s.sizeTouched && s.size != null) {
            var p = curProd(r);
            if (p && (p.sizes || []).some(function (x) { return x.v === s.size; })) { r.size = s.size; r.sizeTouched = true; }
          }
          r.qty = clampQty(s.qty);
          r.on = !!s.on;
        });
      })();

      function sizeText(g, v) {
        var s = String(v == null ? '' : v);
        if (!/cm/i.test(s)) s = s + ' cm';
        // El diametro solo se anota en los redondos, y se decide por el HANDLE de la forma
        // (`rund`), que no se traduce. El simbolo es universal, no hace falta locale.
        if (g && g.shape === 'rund' && s.indexOf('Ø') < 0) s = 'Ø ' + s;
        return s;
      }

      function render() {
        // anti-salto: si el puntero esta sobre una fila, el repintado la reconstruye y el
        // navegador re-aplica :hover un frame tarde -> la miniatura encogia y volvia a crecer.
        // Se marca la fila nueva con .bl-hold en el MISMO tick, antes del primer paint.
        var held = -1;
        var hovEl = rowsEl.querySelector('.bl-addons2__row:hover');
        if (hovEl) held = Array.prototype.indexOf.call(rowsEl.children, hovEl);

        rowsEl.innerHTML = rows.map(function (r, i) {
          var g = r.g, p = curProd(r);
          if (!p) return '';
          syncSize(r, false);
          var se = sizeEntry(r);
          var ok = sellable(r);
          if (!ok) r.on = false;   // sin variante vendible no puede quedarse marcada

          // forma EN NEGRITA junto al nombre (mismo patron que el color en el carril de grifos:
          // "Vana · Negro metalico" va todo en negrita). El nivel de feature, en cambio, se queda
          // en peso normal detras, como el tipo alto/bajo de los grifos.
          var rowTitle = (g.title || p.title || '') + (g.shapeLabel ? ' · ' + g.shapeLabel : '');
          // nivel elegido en peso normal detras del titulo (mismo patron que el tipo de grifo):
          // los labels llegan TRADUCIDOS de los metaobjetos product_features del producto
          // seleccionado y se unen con " + " ("mit Beleuchtung + Antibeschlag"), asi que al
          // pasar de luz a luz+antivaho el titulo cambia solo
          var featLabel = labelsOf(featsOf(p));
          var featText = featLabel ? ((L.withWord ? L.withWord + ' ' : '') + featLabel) : '';
          var img = (se && se.image) || p.image || '';

          var optsHtml = (p.sizes || []).map(function (s) {
            return '<option value="' + esc(s.v) + '"' + (s.v === r.size ? ' selected' : '') + (s.available ? '' : ' disabled') + '>' + esc(sizeText(g, s.v)) + '</option>';
          }).join('');
          var sizeHtml = '<span class="bl-addons2__size"><select data-a2-size="' + i + '" aria-label="' + esc((g.sizeLabel || '') + ' · ' + rowTitle) + '">' + optsHtml + '</select></span>';

          // chips acumulativos: marcados todos los niveles <= elegido (mismo aro para todos; el
          // titulo ya nombra el nivel). Con un solo producto el chip es informativo.
          // Cada chip dibuja lo que su nivel ANADE (normalmente un icono; varios si un nivel
          // salta dos features de golpe).
          var solo = r.prods.length < 2;
          var chipsHtml = r.prods.map(function (fp, li) {
            var lit = li <= r.level;
            var delta = levelDelta(r, li);
            var label = labelsOf(delta) || fp.title || '';
            var icons = delta.filter(function (f) { return f.icon; });
            var inner = icons.length
              ? icons.map(function (f) { return '<img src="' + esc(f.icon) + '" alt="' + esc(f.label || '') + '" loading="lazy">'; }).join('')
              : '<span>' + esc(label) + '</span>';
            return '<button type="button" class="bl-addons2__ficon' + (lit ? ' is-active' : '') + (li === r.level ? ' is-picked' : '') + '"' +
              ' data-a2-row="' + i + '" data-a2-level="' + li + '"' + (solo ? ' disabled' : '') +
              ' aria-pressed="' + (lit ? 'true' : 'false') + '" title="' + esc(label) + '" aria-label="' + esc(label) + '">' + inner + '</button>';
          }).join('');

          var qtyHtml = '<span class="bl-addons2__qty" data-a2-qtywrap="' + i + '" role="group" aria-label="' + esc(L.qty + ' · ' + rowTitle) + '">' +
            '<button type="button" class="bl-addons2__qtybtn" data-a2-qty="' + i + '" data-a2-step="-1" aria-label="' + esc(lblFor(L.dec, rowTitle)) + '"' + (r.qty <= QTY_MIN ? ' disabled' : '') + '>&minus;</button>' +
            '<span class="bl-addons2__qtyval" data-a2-qtyval="' + i + '" aria-live="polite">' + r.qty + '</span>' +
            '<button type="button" class="bl-addons2__qtybtn" data-a2-qty="' + i + '" data-a2-step="1" aria-label="' + esc(lblFor(L.inc, rowTitle)) + '"' + (r.qty >= QTY_MAX ? ' disabled' : '') + '>+</button>' +
          '</span>';

          // el precio es el de la LINEA (unidad x cantidad): con el stepper al lado es lo que el
          // cliente espera ver sumado en el sticky
          var priceHtml = (showPrice && se) ? '<span class="product-addons__price">+' + fmtCents(parseFloat(se.price) * r.qty) + '</span>' : '';

          return '<div class="product-addons__item bl-addons2__row' + (r.on ? ' bl-on' : '') + (ok ? '' : ' bl-addons2__row--soldout') + '">' +
            '<div class="product-addons__image">' + (img ? '<img class="product-addons__img" src="' + esc(img) + '" alt="' + esc(rowTitle) + '" loading="lazy">' : '') + '</div>' +
            '<div class="product-addons__info">' +
              '<strong class="product-addons__title text-sm font-body-bolder">' + esc(rowTitle) +
                (featText ? '<span class="bl-addons2__rowfeat"> · ' + esc(featText) + '</span>' : '') +
              '</strong>' +
              '<span class="bl-addons2__line2">' +
                sizeHtml +
                (chipsHtml ? '<span class="bl-addons2__chips">' + chipsHtml + '</span>' : '') +
                qtyHtml +
                priceHtml +
              '</span>' +
            '</div>' +
            '<div class="product-addons__toggle-wrapper"><label class="product-addons__switch">' +
              '<input type="checkbox" class="product-addons__toggle bl-addons2__toggle" data-a2-toggle="' + i + '"' + (r.on ? ' checked' : '') + (ok ? '' : ' disabled') + ' aria-label="' + esc(rowTitle) + '">' +
              '<span class="product-addons__slider" aria-hidden="true"></span>' +
            '</label></div>' +
          '</div>';
        }).join('');

        if (held > -1 && rowsEl.children[held]) rowsEl.children[held].classList.add('bl-hold');

        // TODO o NADA. La cabecera se pinta aqui, no en Liquid: mientras estuvo en Liquid, un
        // carril que no podia pintar filas dejaba un "Passenden Spiegel hinzufügen?" huerfano
        // encima de un hueco. El bloque nace con [hidden] y solo se descubre si hay filas.
        var painted = rowsEl.children.length > 0;
        if (painted && headEl && !headEl.childElementCount) {
          var ht = root.getAttribute('data-heading') || '';
          if (ht) {
            var hs = root.getAttribute('data-heading-size') || 'h5';
            headEl.innerHTML = '<h3 class="product-addons__heading ' + esc(hs) + ' font-heading">' + esc(ht) + '</h3>';
          }
        }
        root.hidden = !painted;

        publish();
      }

      // refresca SOLO lo que depende de la cantidad, para no reconstruir la fila (y recargar la
      // imagen del espejo) en cada +/-
      function syncQtyRow(i) {
        var r = rows[i]; if (!r) return;
        var wrap = rowsEl.querySelector('[data-a2-qtywrap="' + i + '"]'); if (!wrap) return;
        var val = wrap.querySelector('[data-a2-qtyval="' + i + '"]');
        if (val) val.textContent = r.qty;
        wrap.querySelectorAll('[data-a2-step]').forEach(function (b) {
          var st = +b.getAttribute('data-a2-step');
          b.disabled = st < 0 ? r.qty <= QTY_MIN : r.qty >= QTY_MAX;
        });
        var rowEl = wrap.closest('.bl-addons2__row');
        var priceEl = rowEl && rowEl.querySelector('.product-addons__price');
        var se = sizeEntry(r);
        if (priceEl && se) priceEl.textContent = '+' + fmtCents(parseFloat(se.price) * r.qty);
      }

      // expone la seleccion por fila para el provider compuesto + snapshot para el swap
      function publish() {
        if (stale()) return;   // root de una generacion anterior: no toca el estado del vivo
        window.__blAddonsSecond = window.__blAddonsSecond || {};
        window.__blAddonsSecondSelection = window.__blAddonsSecondSelection || {};
        var snap = window.__blAddonsSecondSelection[sectionId] = {};
        rows.forEach(function (r) {
          var se = sizeEntry(r);
          window.__blAddonsSecond[sectionId + '|' + r.key] = {
            on: r.on,
            qty: r.qty,
            variant: (r.on && se && se.id) ? { id: se.id, price: se.price, available: se.available } : null,
            product: curProd(r),
            family: r.key,
            // imagen de la TALLA elegida (variant.image), o la del producto si la talla no tiene
            // foto propia. Es la que ensena el sticky del ATC; el carrito y el checkout no la
            // necesitan porque Shopify ya coge la imagen nativa de la variante por su cuenta.
            image: (se && se.image) || (curProd(r) && curProd(r).image) || null
          };
          snap[r.key] = { level: r.level, size: r.size, sizeTouched: r.sizeTouched, qty: r.qty, on: r.on };
        });
        root.dispatchEvent(new CustomEvent('bl:addons2:change', { bubbles: true, detail: window.__blAddonsSecond }));
      }

      // 2026-10-15 · elegir medida o nivel (luz / antivaho) ENCIENDE la fila, igual que en el carril
      // de grifos (switchOn de BL-product-addons-v3.js, con el porqué): se marca el checkbox y se
      // dispara su `change`, el mismo camino que un toque en el interruptor (estado, publish() con
      // el precio del botón y __blAddonsSecondSelection, `addon_changed` 'on'). Apagar sigue siendo
      // solo con el interruptor. Fila ya encendida o sin medida vendible: nada.
      function switchOn(i) {
        var r = rows[i]; if (!r || r.on || !sellable(r)) return;
        var t = rowsEl.querySelector('[data-a2-toggle="' + i + '"]');
        if (!t || t.disabled) return;
        t.checked = true;
        t.dispatchEvent(new Event('change', { bubbles: true }));
      }

      root.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-a2-level]');
        if (chip && !chip.disabled) {
          var ci = +chip.getAttribute('data-a2-row');
          var r = rows[ci]; if (!r) return;
          var next = +chip.getAttribute('data-a2-level');
          // pulsar el chip superior YA marcado lo desmarca: baja un nivel (luz + antivaho -> luz).
          // Con todos los chips activos marcados igual, es el gesto natural para quitar el
          // antivaho; el de luz a solas no se puede quitar (todos los espejos llevan luz).
          if (next === r.level) {
            if (r.level === 0) { switchOn(ci); return; }   // elegir «solo luz» también es elegir
            next = r.level - 1;
          }
          r.level = next;
          // al cambiar de nivel se conserva la talla si el producto nuevo la ofrece; si no, se
          // vuelve a resolver contra el mueble (force) aunque la hubiese elegido el cliente
          var p = curProd(r);
          if (!p || !(p.sizes || []).some(function (s) { return s.v === r.size; })) syncSize(r, true);
          render();
          switchOn(ci);
          return;
        }
        var qb = e.target.closest('[data-a2-qty]');
        if (qb) {
          var qi = +qb.getAttribute('data-a2-qty');
          var r2 = rows[qi]; if (!r2) return;
          var nq = clampQty(r2.qty + (+qb.getAttribute('data-a2-step') || 0));
          if (nq === r2.qty) return;
          r2.qty = nq;
          syncQtyRow(qi);
          publish();
          return;
        }
      });

      root.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-a2-size]');
        if (sel) {
          var si = +sel.getAttribute('data-a2-size');
          var r = rows[si]; if (!r) return;
          r.size = sel.value;
          r.sizeTouched = true;   // a partir de aqui manda el cliente, no la medida del mueble
          render();
          switchOn(si);
          return;
        }
        var t = e.target.closest('[data-a2-toggle]');
        if (t) {
          var r2 = rows[+t.getAttribute('data-a2-toggle')]; if (!r2) return;
          r2.on = !!t.checked && sellable(r2);
          t.checked = r2.on;
          var rowEl = t.closest('.bl-addons2__row');
          if (rowEl) rowEl.classList.toggle('bl-on', r2.on);
          publish();
        }
      });

      // suelta el hold anti-salto al salir el puntero de la fila (mouseleave no burbujea, y el
      // listener debe ser delegado porque render() reemplaza los nodos)
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        root.addEventListener('mouseout', function (e) {
          var rowEl = e.target.closest('.bl-addons2__row');
          if (!rowEl || !rowEl.classList.contains('bl-hold')) return;
          if (e.relatedTarget && rowEl.contains(e.relatedTarget)) return;
          rowEl.classList.remove('bl-hold');
        });
      }

      // la medida del mueble cambia por el selector v3 o por el picker de variante nativo
      function onMuebleChange() {
        if (stale()) return;   // el listener del root viejo sobrevive al swap; aqui se para
        if (syncAllSizes()) render(); else publish();
      }
      document.addEventListener('bl:wb3:change', onMuebleChange);
      document.addEventListener('variant:changed', onMuebleChange);
      if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.subscribe) {
        try { window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, onMuebleChange); } catch (e) {}
      }

      // primer pintado: si el selector v3 aun no ha resuelto, su primer bl:wb3:change corrige
      render();

      // Precarga de las imagenes por talla (mismo truco que los colores del carril de grifos):
      // al cambiar el desplegable la miniatura ya esta en cache y no parpadea. Se hace en un
      // hueco de inactividad para no competir con la carga de la PDP, y deduplicada por URL
      // porque una misma foto suele servir a varias tallas. Sin `Image` (arnes en Node) no hace
      // nada; sin imagenes de talla (dato de hoy) tampoco.
      (function preloadSizeImages() {
        if (typeof Image !== 'function') return;
        var seen = {}, urls = [];
        rows.forEach(function (r) {
          r.prods.forEach(function (fp) {
            (fp.sizes || []).forEach(function (s) { if (s.image && !seen[s.image]) { seen[s.image] = 1; urls.push(s.image); } });
          });
        });
        if (!urls.length) return;
        var go = function () { urls.forEach(function (u) { var im = new Image(); im.src = u; }); };
        if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 3000 }); else setTimeout(go, 800);
      })();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('bl:grouping:swapped', init);
})();
